<template>
  <v-btn
    
    prepend-icon="mdi-logout-variant"
    :disabled="isLoading"
    @click="isLoading=true"

  >
    logout
    <!-- <span v-if="isLoading" class="logout-button__spinner"></span>
    <span v-else class="logout-button__icon">
      <svg v-if="showIcon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
        <polyline points="16 17 21 12 16 7"></polyline>
        <line x1="21" y1="12" x2="9" y2="12"></line>
            :class="{
                'logout-button--loading': isLoading,
                'logout-button--small': size === 'small',
                'logout-button--large': size === 'large',
                'logout-button--secondary': variant === 'secondary'
                
                }"
      </svg>
    </span>
    <span v-if="showText" class="logout-button__text">
      {{ isLoading ? loadingText : label }}
    </span> -->
  </v-btn>
  <div class="text-center pa-4">
      <v-dialog
        v-model="isLoading"
        width="400"
      >
        <v-card width="400">
        <v-card-text>
            <p>Êtes-vous sûr de vouloir vous déconnecter ?</p>
        </v-card-text>
        <v-card-actions >
            <v-btn
                text="Annuler"
                @click=" isLoading=false"
                variant="plain"
                color="success"
            ></v-btn>
            
            <v-btn 
                color="danger"
                text="Se déconnecter"
                @click="performLogout();isLoading = false"
                variant="plain"
            ></v-btn>
            
        </v-card-actions> 
            <!-- <v-img
                width="600"
                cover
                :src="srcImage"
            ></v-img> -->
        </v-card>
      </v-dialog>
    </div>
</template>

<script setup>
import { ref, defineProps } from 'vue'
import { useRouter } from 'vue-router'
import store from '../store'
const props = defineProps({
  // Texte du bouton
  label: {
    type: String,
    default: 'Déconnexion'
  },
  loadingText: {
    type: String,
    default: 'Déconnexion...'
  },
  
  // Apparence
  size: {
    type: String,
    default: 'medium', // 'small', 'medium', 'large'
    validator: (value) => ['small', 'medium', 'large'].includes(value)
  },
  variant: {
    type: String,
    default: 'primary', // 'primary', 'secondary'
    validator: (value) => ['primary', 'secondary'].includes(value)
  },
  showIcon: {
    type: Boolean,
    default: true
  },
  showText: {
    type: Boolean,
    default: true
  },
  
  // Comportement
  confirmBeforeLogout: {
    type: Boolean,
    default: false // Mettre à true si vous voulez une confirmation
  },
  redirectTo: {
    type: String,
    default: '/login'
  },
  clearAllData: {
    type: Boolean,
    default: true
  },
  
  // Événements personnalisés
  onBeforeLogout: {
    type: Function,
    default: null
  },
  onAfterLogout: {
    type: Function,
    default: null
  }
})

const router = useRouter()
const isLoading = ref(false)

// Fonction principale de déconnexion
const performLogout = async () => {
//   if (isLoading.value) return
//   isLoading.value = true
  
  try {
    // 1. Appeler la fonction personnalisée avant déconnexion
    store.commit('addUser',{})
    if (props.onBeforeLogout) {
      await props.onBeforeLogout()
    }
    
    // 2. Déconnexion du store d'authentification (si Pinia est utilisé)
    const authStore = window.authStore // À adapter selon votre implémentation
    if (authStore && typeof authStore.logout === 'function') {
      await authStore.logout()
    }
    
    // 3. Nettoyage complet du navigateur
    if (props.clearAllData) {
      // LocalStorage
      localStorage.clear()
      
      // SessionStorage
      sessionStorage.clear()
      
      // Cookies
      document.cookie.split(';').forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim()
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
      })
      
      // IndexedDB (optionnel)
      if (window.indexedDB) {
        const databases = await window.indexedDB.databases()
        databases.forEach(db => {
          if (db.name) window.indexedDB.deleteDatabase(db.name)
        })
      }
      
      // Service Worker (si utilisé)
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations()
        registrations.forEach(registration => registration.unregister())
      }
      
      // Cache API
      if ('caches' in window) {
        const cacheKeys = await caches.keys()
        await Promise.all(cacheKeys.map(key => caches.delete(key)))
      }
    }
    
    // 4. Redirection
    await router.push(props.redirectTo)
    
    // 5. Forcer un rafraîchissement complet (optionnel)
    // window.location.href = props.redirectTo
    
    // 6. Appeler la fonction personnalisée après déconnexion
    if (props.onAfterLogout) {
      await props.onAfterLogout()
    }
    
  } catch (error) {
    console.error('Erreur lors de la déconnexion:', error)
    
    // En cas d'erreur, rediriger quand même
    router.push(props.redirectTo)
    
  } finally {
    isLoading.value = false
  }
}

// Gestion du clic
// const handleLogout = async () => {
//   if (props.confirmBeforeLogout) {
//     const confirmed = window.confirm('Êtes-vous sûr de vouloir vous déconnecter ?')
//     if (confirmed) {
//       await performLogout()
//     }
//   } else {
//     await performLogout()
//   }
// }
</script>

<style scoped>
.logout-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 40px;
  user-select: none;
}

.logout-button:hover:not(:disabled) {
  background-color: #b91c1c;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);
}

.logout-button:active:not(:disabled) {
  transform: translateY(0);
}

.logout-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Variantes de taille */
.logout-button--small {
  padding: 6px 12px;
  font-size: 12px;
  min-height: 32px;
  gap: 6px;
}

.logout-button--medium {
  padding: 8px 16px;
  font-size: 14px;
  min-height: 40px;
  gap: 8px;
}

.logout-button--large {
  padding: 12px 24px;
  font-size: 16px;
  min-height: 48px;
  gap: 10px;
}

/* Variantes de style */
.logout-button--secondary {
  background-color: #6b7280;
}

.logout-button--secondary:hover:not(:disabled) {
  background-color: #4b5563;
  box-shadow: 0 4px 12px rgba(107, 114, 128, 0.2);
}

/* Version icon-only */
.logout-button:not(.logout-button--large) .logout-button__icon svg {
  width: 14px;
  height: 14px;
}

.logout-button--large .logout-button__icon svg {
  width: 18px;
  height: 18px;
}

/* Spinner */
.logout-button__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Version responsive */
@media (max-width: 640px) {
  .logout-button:not(.logout-button--small) {
    padding: 6px 12px;
    font-size: 13px;
    min-height: 36px;
  }
  
  .logout-button__text {
    display: inline;
  }
}
</style>